<template>
    <div  :id="`comp${  idk  }`"  class="p-relative"  style="overflow:visible; font-size:0.8rem;"  :style="`width:${ r*2 + lineWidth }px; height:${ r*2 + lineWidth }px;`">
        <canvas
            id="canvas"
            class="p-radius50"
            :style="`background:${  canvasColor  };`"
            :width="`${ r*2 + lineWidth }`"
            :height="`${ r*2 + lineWidth }`"
        >
        </canvas>


        <div
            v-if="Math.round(deg/360*100)"
            class="p-wh100"
            style="position:absolute; left:0px; top:0px; color:green"
            :style="`transform:rotate(${  deg/2  }deg);`"
        >
            <div  style="padding:20px;"  :style="`transform:rotate(${  (-1)*deg/2  }deg);`">
                <span  v-show="isShowNum">{{  Math.round(deg/360*100)  }}%</span>
            </div>
        </div>


        <div
                class="p-wh100"
                style="position:absolute; left:0px; top:0px;"
                :style="`transform:rotate(${  deg/2+180  }deg);`"
        >
            <div  style="padding:20px;"  :style="`transform:rotate(${  (-1)*deg/2+180  }deg);`">
                <span  v-show="isShowNum">{{  100 - Math.round(deg/360*100)  }}%</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "pie",
        data(){
            return {
                idk:Math.round(Math.random()*1000000),  // 避免多个组件使用时，id冲突
            }
        },
        props:{
            canvasColor:{  type:String, required:false, default:"#eeeeee"  },   // rgba(0,0,0,0)  rgba(245,125,49,0.3)
            fillColor:{  type:String, required:false, default:"#ff5b37"  },     // (0,100)
            lineColor:{  type:String, required:false, default:"white"  },
            lineWidth:{  type:Number, required:false, default:8  },   // 画图时的线宽


            r:{  type:Number, required:false, default:50  },
            deg:{  type:Number, required:false, default:30  },
            degArray:{  type:Array, required:false, default:[]  },
            colorArray:{  type:Array, required:false, default:[]  },
            isShowNum:{  type:Boolean, required:false, default:false  },
        },
        methods:{
            pie(){
                let docu = document.querySelector(`#comp${  this.idk  }`);
                let oCanvas = docu.querySelector("#canvas");
                let context = oCanvas.getContext("2d");
                let oldAngle=-90;
                if(  this.deg > 0  ){
                    context.beginPath();
                    context.lineWidth=this.lineWidth;
                    context.strokeStyle=this.lineColor;
                    context.fillStyle=this.fillColor;

                    context.moveTo(  this.r + this.lineWidth*0.5, this.r + this.lineWidth*0.5  );
                    context.arc(  this.r + this.lineWidth*0.5, this.r + this.lineWidth*0.5, this.r,-90*Math.PI/180,(-90+this.deg)*Math.PI/180  );
                    context.closePath();
                    context.stroke();
                    context.fill();

                    context.beginPath();
                    context.closePath();
                }else if(this.degArray!=undefined&&this.degArray.length>0){
                    // console.log('this.degArray=',this.degArray);
                    oldAngle=0;
                    for(let i=0;i<this.degArray.length;i++){
                        context.beginPath();
                        context.lineWidth=this.lineWidth;
                        context.strokeStyle=this.lineColor;
                        context.fillStyle=this.colorArray[i];
                        context.moveTo(  this.r + this.lineWidth*0.5, this.r + this.lineWidth*0.5  );
                        //  console.log('this.r + this.lineWidth*0.5=',this.r + this.lineWidth*0.5);
                        context.arc(  this.r + this.lineWidth*0.5, this.r + this.lineWidth*0.5, this.r,(oldAngle*Math.PI/180),((oldAngle+this.degArray[i])*Math.PI/180));
                        // console.log('oldAngle=',oldAngle);
                        oldAngle=oldAngle+this.degArray[i];
                        // console.log('new oldAngle=',oldAngle);
                        context.closePath();
                        context.stroke();
                        context.fill();
                    }
                    context.beginPath();
                    context.closePath();
                }

            },
        },
        mounted(){
            this.pie();
        }
    }
</script>

<style scoped>

</style>